var map = {
	"./Cast.svg": "969e",
	"./Room.svg": "b9f7",
	"./altfBanner.svg": "c753",
	"./arrowDown.svg": "f266",
	"./blank-feed/0.png": "dbd5",
	"./blank-feed/1.png": "2e51",
	"./blank-feed/10.png": "4d3b",
	"./blank-feed/11.png": "4735",
	"./blank-feed/12.png": "6288",
	"./blank-feed/13.png": "2842",
	"./blank-feed/14.png": "c7d6",
	"./blank-feed/2.png": "4a8b",
	"./blank-feed/3.png": "2843",
	"./blank-feed/4.png": "8af6",
	"./blank-feed/5.png": "001f",
	"./blank-feed/6.png": "33b9",
	"./blank-feed/7.png": "2ce4",
	"./blank-feed/8.png": "312d",
	"./blank-feed/9.png": "9e9d",
	"./calendarIcon.svg": "b399",
	"./crossIcon.svg": "8b1e",
	"./empty-box.svg": "52b4",
	"./gbLogo.svg": "f3b4",
	"./gtb-logo.svg": "e662",
	"./headphone.svg": "86a3",
	"./info.svg": "c7ec",
	"./mapIcon.svg": "0b61",
	"./news.svg": "f7ec",
	"./no-feed-data.svg": "ad2a",
	"./no-feed.svg": "3e5a",
	"./no-quest.svg": "08a4",
	"./no_msg.svg": "acc4",
	"./play.svg": "65d6",
	"./project.svg": "5a5c",
	"./soft.svg": "1108",
	"./tech.svg": "afbe",
	"./wallet-widget-background-1.png": "b688",
	"./wallet-widget-background-2.png": "b166",
	"./walletcard_bg.png": "ee937",
	"./walletcard_chip.png": "7787",
	"./walletcard_logo.png": "ec72"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5dcf";